import React, { FC, useEffect, useState } from 'react';
import { Col, Form, Row, Space, Upload, UploadProps } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { RcFile } from 'antd/es/upload';
import { api, endpoints } from '../../../../api';
import {
  CloseButton,
  CustomButton,
  CustomCheckbox,
  DownloadCol,
  FormBlock,
  FormInput,
  FormItem,
} from '../../../../styles/styled';
import { getBase64 } from '../../../../utils/convertToBase64';
import { FileDataType } from '../../../NewApplicationPage/types';
import { DocumentFileDataType, FileResponseType } from './types';

type AddFileFormProps = {
  removeForm: (index: number) => void;
  setForm: (index: number, res: DocumentFileDataType) => void;
  fileData: DocumentFileDataType;
};

export const AddFileForm: FC<AddFileFormProps> = ({ removeForm, setForm, fileData }) => {
  const [loadState, setLoadState] = useState<boolean>(false);
  const [fileLoadState, setFileLoad] = useState<FileDataType | null>(null);

  useEffect(() => {
    if (loadState && fileLoadState) {
      (async () => {
        try {
          const response = await api.post<FileResponseType>(endpoints.addFile(), fileLoadState);
          setLoadState(false);
          setForm(fileData.id ? fileData.id : 1, {
            ...fileData,
            file: { id: response.data.file_id },
          });
        } catch (err) {}
      })();
    }
    // eslint-disable-next-line
  }, [loadState, fileLoadState]);

  const handleTextbook: UploadProps['onChange'] = (info) => {
    getBase64(info.file.originFileObj as RcFile, (url) =>
      setFileLoad({
        base64: url.split('base64,')[1],
        title: info.file.name as string,
        ext: info.file.type as string,
      }),
    );
  };

  return (
    <FormBlock position="relative">
      <CloseButton positioned onClick={() => removeForm(fileData.id ? fileData.id : 1)}>
        +
      </CloseButton>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <FormItem>
            <CustomCheckbox
              checked={fileData?.expire}
              onChange={(e: CheckboxChangeEvent) =>
                setForm(fileData.id ? fileData.id : 1, { ...fileData, expire: e.target.checked })
              }
            >
              <p>Утратил силу</p>
            </CustomCheckbox>
          </FormItem>
        </Col>
        <Col span={13}>
          <FormItem redstar>
            <p>Наименование</p>
            <Form.Item
              label="Наименование"
              initialValue={fileData.name}
              name={`name${fileData.id}`}
              rules={[{ required: true, message: 'Пожалуйста, введите наименование подраздела' }]}
            >
              <FormInput
                value={fileData.name}
                onChange={(e) => setForm(fileData.id ? fileData.id : 1, { ...fileData, name: e.target.value })}
                defaultValue={undefined}
              />
            </Form.Item>
          </FormItem>
        </Col>
        <Col span={13}>
          <FormItem>
            <p>Сортировка</p>
            <FormInput
              value={fileData?.sort}
              type="number"
              onChange={(e) => setForm(fileData.id ? fileData.id : 0, { ...fileData, sort: parseInt(e.target.value) })}
            />
          </FormItem>
        </Col>
        <DownloadCol span={24} style={{ paddingLeft: '35px' }}>
          <Space align="center">
            {(fileLoadState || fileData.file) && (
              <button className="remove-button" onClick={() => setFileLoad(null)}>
                +
              </button>
            )}
            {!fileLoadState && !fileData.file && (
              <Upload
                accept=".pdf, .png, .jpg, .jpeg"
                onChange={handleTextbook}
                name="avatar"
                className={'avatar-uploader'}
                showUploadList={false}
              >
                <div className={'download-layout'}>Загрузить файл</div>
              </Upload>
            )}
            {(fileLoadState || fileData.file) && (
              <>
                <CustomButton padding="5px 10px" lowercase lined width="auto">
                  {fileLoadState?.title ? fileLoadState.title : fileData.file?.file_path}
                </CustomButton>
                {fileLoadState && <FormInput defaultValue={1} width={'60px'} type="number" />}

                {fileLoadState && (
                  <CustomButton
                    type="button"
                    onClick={() => setLoadState(true)}
                    width="auto"
                    lowercase
                    padding="5px 10px"
                  >
                    Загрузка файла
                  </CustomButton>
                )}
              </>
            )}
          </Space>
          <p>рекомендуется прикреплять файл в формате .pdf</p>
        </DownloadCol>
      </Row>
    </FormBlock>
  );
};
